/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosports3ColumnImagesData } from './hosports-3-column-images.data';
import { IHosports3ColumnImagesProps } from './hosports-3-column-images.props.autogenerated';

export interface IHosports3ColumnImagesViewProps extends IHosports3ColumnImagesProps<IHosports3ColumnImagesData> {

}

/**
 *
 * Hosports3ColumnImages component
 * @extends {React.PureComponent<IHosports3ColumnImagesProps<IHosports3ColumnImagesData>>}
 */
class Hosports3ColumnImages extends React.PureComponent<IHosports3ColumnImagesProps<IHosports3ColumnImagesData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default Hosports3ColumnImages;
